import { message } from "antd";
import InternalApi from "../axios/internalApi";

export const fetchSponsors = async () => {
  try {
    return await InternalApi.get({
      server: "api/v1/",
      path: "sponsor/list"
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const createSponsor = async (formData) => {
  try {
    return await InternalApi.postImage(
      {
        server: "api/v1/",
        path: "sponsor/new?folder=SPONSOR",
      },
      formData
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const updateSponsorStatus = async (id, isActive) => {
  try {
    return await InternalApi.patch(
      {
        server: "api/v1/",
        path: `sponsor/update/${id}`,
      },
      { isActive }
    );
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const deleteSponsor = async (id) => {
  try {
    return await InternalApi.delete({
      server: "api/v1/",
      path: `sponsor/${id}`,
    });
  } catch (error) {
    message.error(error?.data?.message);
    throw error;
  }
};